import styled from 'styled-components';

import { ProcedureAutosuggest } from '~libs.desktop.shared.visit-medical-documents.procedures';

export const StyledProcedureField = styled(ProcedureAutosuggest)`
   width: 100%;
`;
